import { isToday, parseISO } from 'date-fns';

import { COLORS } from '@/shared/lib';
import { Typography } from '@/shared/ui';

import { ExchangeRateData, ExchangeRatePayload } from '../model/types';

interface CustomDotProps {
  cx?: number;
  cy?: number;
  index?: number;
  rates?: ExchangeRateData[];
}
interface CustomYAxisTickProps {
  todayValue: number;
  x?: number;
  y?: number;
  payload?: {
    value?: number;
  };
}
interface ExchangeRateTooltipProps {
  currency: string;
  active?: string;
  payload?: ExchangeRatePayload[];
}

export const ExchangeRateTooltip = ({
  active,
  payload,
  currency,
}: ExchangeRateTooltipProps) => {
  if (!active || !payload || payload.length === 0) {
    return null;
  }
  const { rate, date } = payload[0].payload;
  const parsedDate = parseISO(date);
  const formattedDate = isToday(parsedDate)
    ? 'Now'
    : parsedDate.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
      });
  return (
    <div className="flex flex-col rounded-2xl bg-contrast-500 px-3 py-2">
      <Typography variant="14-r" className="whitespace-nowrap text-black">
        {rate.toFixed(2)} {currency}
      </Typography>
      <Typography variant="14-r" className="whitespace-nowrap text-base-300">
        {formattedDate}
      </Typography>
    </div>
  );
};
export const CustomDot = ({ cy, cx, index, rates }: CustomDotProps) => {
  if (!rates) return null;
  if (index === rates.length - 1) {
    return (
      <g>
        <circle cx={cx} cy={cy} r={6} fill={COLORS['icon-base-500']} />
      </g>
    );
  }
  return null;
};

export const CustomYAxisTick = ({
  x,
  y,
  payload,
  todayValue,
}: CustomYAxisTickProps) => {
  const isTodayValue = payload?.value === todayValue;
  return (
    <text
      x={x}
      y={y}
      dy={4}
      style={{
        fill: isTodayValue ? COLORS['icon-base-500'] : COLORS['base-100'],
      }}
    >
      {payload?.value?.toFixed(2)}
    </text>
  );
};

export const CustomActiveDot = ({ cx, cy }: CustomDotProps) => {
  return (
    <g>
      <line
        x1={cx}
        y1={0}
        x2={cx}
        y2="100%"
        width={1}
        stroke={COLORS['icon-base-500']}
      />
      <circle
        cx={cx}
        cy={cy}
        r={6}
        fill={COLORS['bg-brand-500']}
        stroke={COLORS['icon-base-500']}
        strokeWidth={2}
      />
    </g>
  );
};
